import { GridColDef, useGridApiRef } from '@mui/x-data-grid-pro'
import { sortBy } from 'lodash'
import { ReactElement, useMemo } from 'react'
import { Project_Goal_Measure } from 'src/@types/graphql'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { DataGridContainer } from 'src/shared/grid/DataGridContainer'
import { getGridStringsOperatorsIgnoreAccents } from 'src/shared/grid/DataGridFilters'
import { S } from 'src/shared/styled/S'
import { useGridTranslateHook } from 'src/shared/utils/hooks/grid-translate-hook'

interface Props {
  goals: Project_Goal_Measure[]
}

export const ProjectMeasureRelatedGoalsGrid = ({ goals }: Props): ReactElement => {
  const gridTranslations = useGridTranslateHook()
  const gridRef = useGridApiRef()
  const { getMessage } = useMessageSource()

  const rows = useMemo(() => {
    return sortBy(goals, ['project_goal.sort_number']).map((goal) => {
      return {
        id: `${getMessage(`label.goal.id.character`)}${goal.project_goal.sort_number}`,
        title: goal.project_goal.name,
      }
    })
  }, [goals, getMessage])

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'id',
        flex: 0.5,
        headerName: getMessage('label.id'),
      },
      {
        field: 'title',
        flex: 2,
        headerName: getMessage('label.title'),
        filterOperators: getGridStringsOperatorsIgnoreAccents(),
      },
    ],
    [getMessage],
  )

  return (
    <DataGridContainer>
      <S.DataGrid.ViewEditMode
        rows={rows}
        columns={columns}
        apiRef={gridRef as any}
        localeText={gridTranslations}
        disableColumnSelector
        disableColumnReorder
        disableColumnPinning
        disableRowSelectionOnClick
        hideFooter
        $viewMode
        sx={{ marginTop: 1 }}
      />
    </DataGridContainer>
  )
}
